export const round = (x: number, decimalPlaces: number): number => {
  const factorOfTen = 10 ** decimalPlaces;
  const rounded = Math.round((x + Number.EPSILON) * factorOfTen) / factorOfTen;
  return rounded;
};
